import { useContext } from 'react';

import { SoundContext } from '../sound-context';

export function useSoundDisabled(): [boolean, (value: boolean) => void] {
  const ctx = useContext(SoundContext);
  if (!ctx)
    throw new Error('useSoundDisabled must be used within SoundProvider');
  return [ctx.soundDisabled, ctx.setSoundDisabled];
}
